import {
  CheckoutStartedEvent,
  CouponAppliedEvent,
  OrderPlacedEvent,
  PaymentInfoAddedEvent,
  ShippingInfoAddedEvent,
} from '../../../checkout/CheckoutPageEvents';
import { IEventAggregator } from '../../EventAggregator';
import { Analytics } from '../Analytics';
import { CheckoutEventDataConverter } from '../converters/CheckoutEventDataConverter';

export class CheckoutAnalyticsListener {
  constructor(eventAggregator: IEventAggregator) {
    eventAggregator.subscribe(CheckoutStartedEvent, (e) => this.onCheckoutStarted(e));
    eventAggregator.subscribe(CouponAppliedEvent, (e) => this.onCouponApplied(e));
    eventAggregator.subscribe(ShippingInfoAddedEvent, (e) => this.onShippingInfoAdded(e));
    eventAggregator.subscribe(PaymentInfoAddedEvent, (e) => this.onPaymentInfoAdded(e));
    eventAggregator.subscribe(OrderPlacedEvent, (e) => this.onOrderPlaced(e));
  }

  private onCheckoutStarted(e: CheckoutStartedEvent) {
    Analytics.trackBeginCheckout(CheckoutEventDataConverter.fromShoppingCartData(e.shoppingCart, e.discountCode));
  }

  private onCouponApplied(e: CouponAppliedEvent) {
    Analytics.trackApplyCoupon({
      ...CheckoutEventDataConverter.fromShoppingCartData(e.shoppingCart, e.discountCode),
      discountCode: e.discountCode,
    });
  }

  private onShippingInfoAdded(e: ShippingInfoAddedEvent) {
    Analytics.trackAddShippingInfo({
      ...CheckoutEventDataConverter.fromShoppingCartData(e.shoppingCart, e.discountCode),
      // Are there any other shipping tiers? If so, take it from shoppingCart.shipments[0].shippingRate.name
      shippingTier: 'Home delivery',
    });
  }

  private onPaymentInfoAdded(e: PaymentInfoAddedEvent) {
    Analytics.trackAddPaymentInfo({
      ...CheckoutEventDataConverter.fromShoppingCartData(e.shoppingCart, e.discountCode),
      paymentType: e.paymentType,
    });
  }

  private onOrderPlaced(e: OrderPlacedEvent) {
    Analytics.trackPurchase(CheckoutEventDataConverter.fromOrderData(e.order, e.discountCode));
  }
}
